<template>
	<div class="merchant_content">
		<!--		<div class="selected_merchant d_flex justify_between">-->
		<!--			<div class="d_flex align_items_center">-->
		<!--				<span class="icon_language"></span>-->
		<!--				{{ $t('merchant_management.setup.language') }}-->
		<!--			</div>-->
		<!--			<div class="d_flex align_items_center">-->
		<!--				<select v-model="s_locale_code" id="select_language">-->
		<!--					<option v-for="item in locales" :value="item.code" :key="item.code">-->
		<!--						{{ item.name }}-->
		<!--					</option>-->
		<!--				</select>-->
		<!--				<span class="down_icon icon"></span>-->
		<!--			</div>-->
		<!--		</div>-->
		<ul>
			<li class="list_item" @click="toRoute({ name: 'setup-notice' })">
				<a class="title_m">{{ $t('merchant.title4') }}</a>
				<span class="right_arrow icon"></span>
			</li>
			<li class="list_item" @click="toRoute({ name: 'setup-faq' })">
				<a class="title_m">{{ $t('merchant.menu_2.menu4') }}</a>
				<span class="right_arrow icon"></span>
			</li>
			<li class="list_item" @click="toRoute({ name: 'setup-cs' })">
				<a class="title_m">{{ $t('merchant.title5') }}</a>
				<span class="right_arrow icon"></span>
			</li>
			<li class="list_item" @click="toRoute({ name: 'terms' })">
				<a class="title_m">{{ $t('merchant_management.setup.terms') }}</a>
				<span class="right_arrow icon"></span>
			</li>
		</ul>
		<div class="d_flex align_items_center pa_1">
			{{ $t('merchant_management.setup.push_notification') }}
			<div class="switch_toggle ml_10">
				<label>
					<input type="checkbox" true-value="Y" false-value="N" />
					<span></span>
				</label>
			</div>
		</div>
		<span class="border_bottom" @click="logoutHandler">{{
			$t('menu.logout')
		}}</span>
	</div>
</template>

<script>
export default {
	name: 'Setup',
	data() {
		return {
			isShowList: true,
		};
	},
	methods: {
		toRoute(obj) {
			this.isMenuOpen = false;
			this.$router.push(obj);
		},
		logoutHandler() {
			let logout_confirm = confirm(this.$t('alert.logout'));
			if (logout_confirm) {
				this.$store.dispatch('auth/logout');
				this.$router.push({ name: 'management' });
			}
		},
	},
};
</script>

<style scoped></style>
